import {Decoder, field, number, object, string} from 'json-bouncer'

export interface ParcelDispatcher {
    id: number
    name: string
    trackingUrl: string
}

export function parcelDispatcherDecoder(): Decoder<ParcelDispatcher> {
    return object({
        id: field('id', number()),
        name: field('name', string()),
        trackingUrl: field('trackingUrl', string()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ParcelDispatcher.ts